import Hero from "../components/home-section/hero";
import BeautyInMotion from "../components/home-section/beauty-in-motion";
import TransformLook from "../components/home-section/transform-look";
import Services from "../components/home-section/services";
import Shop from "../components/home-section/shop";
import Instagram from "../components/home-section/instagram";
import Reviews from "../components/home-section/reviews";
import { useInstagram } from "../contexts/InstagramContexts";

const Home = () => {
  const { loading, error } = useInstagram();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="flex justify-center items-center py-10">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[#b05d5d]"></div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-red-500 text-center p-4">
          <p>{error}</p>
          <p>Please refresh the page or try again later.</p>
        </div>
      </div>
    );
  }
  return (
    <>
      <Hero />
      <BeautyInMotion />
      {/* <TransformLook /> */}
      <Services />
      <Reviews />
      {/* <Shop /> */}
      {/* <Instagram /> */}
    </>
  );
};

export default Home;
